import { BaseNutritionItem, NutritionSection } from './types';

export type FoodComponent = BaseNutritionItem;

export const getFoodComponentsData = (
  t: (key: string, options?: Record<string, unknown>) => string
): NutritionSection => ({
  sectionTitle: t('food.info.core.sectionTitle'),
  notes: t('food.info.core.notes'),
  items: [
    {
      component: t('food.info.core.items.carbohydrates.component'),
      summary: t('food.info.core.items.carbohydrates.summary'),
      role: t('food.info.core.items.carbohydrates.role'),
      sources: t('food.info.core.items.carbohydrates.sources'),
    },
    {
      component: t('food.info.core.items.protein.component'),
      summary: t('food.info.core.items.protein.summary'),
      role: t('food.info.core.items.protein.role'),
      sources: t('food.info.core.items.protein.sources'),
    },
    {
      component: t('food.info.core.items.fats.component'),
      summary: t('food.info.core.items.fats.summary'),
      role: t('food.info.core.items.fats.role'),
      sources: t('food.info.core.items.fats.sources'),
    },
    {
      component: t('food.info.core.items.calories.component'),
      summary: t('food.info.core.items.calories.summary'),
      role: t('food.info.core.items.calories.role'),
    },
    {
      component: t('food.info.core.items.water.component'),
      summary: t('food.info.core.items.water.summary'),
      role: t('food.info.core.items.water.role'),
      sources: t('food.info.core.items.water.sources'),
    },
    {
      component: t('food.info.core.items.fiber.component'),
      summary: t('food.info.core.items.fiber.summary'),
      role: t('food.info.core.items.fiber.role'),
      sources: t('food.info.core.items.fiber.sources'),
    },
  ],
});